// extracted by mini-css-extract-plugin
export var pulse = "aiZKSxHIYDTQgeSmp4gO";
export var shimmering = "AAZeQWFxwmoi8bTR8gcg";